<section id="content">
  <form id="form">
    <div class="row">
      <div class="col-md-12 col-xs-12 table-cont">
        <div class="form-group">
          <div class="card">
            <div class="card-title">
              <h2>Stocks</h2>
            </div>
            <div class="cont">
              <div class="group">
                <div class="collapse-title">
                  Stocks
                  <i class="collapse-icon fa"></i>
                </div>
                <div class="table-responsive">
                  <p-table #dt6 (onFilter)="captureFilteredStockIds(dt6)"styleClass="ui-table-customers" tableStyleClass="table table-responsive"
                    [value]="stocks" dataKey="stockId" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                    [rowsPerPageOptions]="[10, 25, 50]" [paginator]="true" [resizableColumns]="true" [autoLayout]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
                    [scrollable]="true"
                    [globalFilterFields]="['itemName', 'productTypeName', 'customerName', 'opportunity.opportunityName']"
                    sortField="stockId" sortOrder="-1">
                    <ng-template pTemplate="caption">
                      <div class="flex" style="float: left;">
                        <p-button
                          *ngIf=" (authenticationService.applanceRole.accessLevel ||0 ) >= accessLevelEnum.read_write"
                          label="Add Stock" [outlined]="true" icon="pi pi-plus-circle"
                          (onClick)="showDialog()"></p-button>
                      </div>
                      <div style="text-align: right">
                        <!-- <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                          (click)="exportExcel()" style="margin-right: 0.5em;" class="ui-button-success"></button>
                        <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF"
                          (click)="exportPdf()" class="ui-button-warning"></button> -->

                          <p-splitButton 
                          label="Excel" 
                          icon="pi pi-file-excel" 
                          iconPos="left"
                          (onClick)="exportExcel()" 
                          style="margin-right: 0.5em;"
                          class="ui-button-success"
                          [model]="excelItems"
                          appendTo="body">
                        </p-splitButton>

                        <!-- SplitButton for PDF Exports -->
                        <p-splitButton 
                          label="PDF" 
                          icon="pi pi-file-pdf" 
                          (onClick)="exportPdf()" 
                          class="ui-button-warning"
                          [model]="pdfItems"
                          appendTo="body">
                        </p-splitButton>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th width="1.5%">#</th>
                        <th pSortableColumn="batchNumber" width="9%">
                          <div class="flex align-items-center">
                            Batch Number
                            <p-sortIcon field="batchNumber"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="productKind" width="9%">
                          <div class="flex align-items-center">
                            Product Kind
                            <p-sortIcon field="productKind"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="categoryName" width="9%">
                          <div class="flex align-items-center">
                            Category
                            <p-sortIcon field="categoryName"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="productTypeName" width="10.5%">
                          <div class="flex align-items-center">
                            Product Type
                            <p-sortIcon field="productTypeName"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="itemName" width="8.5%">
                          <div class="flex align-items-center">
                            Item Name
                            <p-sortIcon field="itemName"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="quantity" width="8.3%">
                          <div class="flex align-items-center">
                            Quantity
                            <p-sortIcon field="quantity"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="availableQuantity" width="8.3%">
                          <div class="flex align-items-center">
                            Available Quantity
                            <p-sortIcon field="availableQuantity"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="stockCoverageStartDate" width="10%">
                          <div class="flex align-items-center">
                            Start Date
                            <p-sortIcon field="stockCoverageStartDate"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="stockCoverageEndDate" width="10%">
                          <div class="flex align-items-center">
                            Coverage Date
                            <p-sortIcon field="stockCoverageEndDate"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="status" width="9%">
                          <div class="flex align-items-center">
                            Status
                            <p-sortIcon field="status"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="customerName" width="9%">
                          <div class="flex align-items-center">
                            Customer
                            <p-sortIcon field="customerName"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="stockOwner" width="9%">
                          <div class="flex align-items-center">
                            Stock Owner
                            <p-sortIcon field="stockOwner"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="purchaseDate" width="9%">
                          <div class="flex align-items-center">
                            Purchase Date
                            <p-sortIcon field="purchaseDate"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="opportunity.opportunityName" width="9.5%">
                          <div class="flex align-items-center">
                            Opportunity
                            <p-sortIcon field="opportunity.opportunityName"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="price" width="7.5%">
                          <div class="flex align-items-center">
                            Price
                            <p-sortIcon field="price"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="poNumber" width="7.5%">
                          <div class="flex align-items-center">
                            PO Number
                            <p-sortIcon field="poNumber"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="rabet" width="7.5%">
                          <div class="flex align-items-center">
                            Rabet
                            <p-sortIcon field="rabet"></p-sortIcon>
                          </div>
                        </th>
                        <th pSortableColumn="customerStock" width="7.5%">
                          <div class="flex align-items-center">
                            Sbm Stock
                            <p-sortIcon field="customerStock"></p-sortIcon>
                          </div>
                        </th>
                        <th style="width: 10rem" alignFrozen="right" pFrozenColumn
                          *ngIf=" (authenticationService.applanceRole.accessLevel ||0 ) >= accessLevelEnum.read_write">
                          Actions</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>
                          <p-columnFilter field="batchNumber" type="text" display="menu"
                            placeholder="Batch No"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="productKind" type="text" display="menu"
                            placeholder="Product Kind"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="categoryName" type="text" display="menu"
                            placeholder="Category"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="productTypeName" type="text" display="menu"
                            placeholder="Product Type"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="itemName" type="text" display="menu"
                            placeholder="Item Name"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="quantity" type="numeric" display="menu"
                            placeholder="Quantity"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="availableQuantity" type="numeric" display="menu"
                            placeholder="Available Quantity"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="stockCoverageStartDate" type="date" display="menu"
                            placeholder="Start Date"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="stockCoverageEndDate" type="date" display="menu"
                            placeholder="Coverage Date"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="status" type="text" display="menu"
                            placeholder="status"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="customerName" type="text" display="menu"
                            placeholder="Customer"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="stockOwner" type="text" display="menu"
                            placeholder="Stock Owner"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="purchaseDate" type="date" display="menu"
                            placeholder="Purchase Date"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="opportunity.opportunityName" type="text" display="menu"
                            placeholder="Opportunity"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="price" type="numeric" display="menu"
                            placeholder="Price"></p-columnFilter>
                        </th>
                        <th>
                          <p-columnFilter field="poNumber" type="text" display="menu"
                            placeholder="PO Number"></p-columnFilter>
                            
                        </th>
                        <th>
                        
                            <p-columnFilter type="boolean" field="rabet" display="menu" placeholder="Rabet"></p-columnFilter>

                        </th>
                        <th>
                        
                            <p-columnFilter type="boolean" field="customerStock" display="menu" placeholder="Sbm Stock"></p-columnFilter>


                        <th alignFrozen="right" pFrozenColumn
                          *ngIf="(authenticationService.applanceRole.accessLevel ||0 ) >= accessLevelEnum.read_write">
                        </th>
                        <th alignFrozen="right" pFrozenColumn
                          *ngIf="(authenticationService.applanceRole.accessLevel ||0 ) >= accessLevelEnum.read_write">
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-stock let-rowIndex="rowIndex">
                      <tr>
                        <td>{{ rowIndex + 1 }}</td>
                        <td>{{ stock.batchNumber }}</td>
                        <td>{{ stock.productKind }}</td>
                        <td>{{ stock.categoryName }}</td>
                        <td>{{ stock.productTypeName ==  null && stock.categoryName == 'Service' ? 'service' :stock.productTypeName  }}</td>
                        <td>{{ stock.itemName }}</td>
                        <td>{{ stock.quantity }}</td>
                        <td>{{ stock.availableQuantity }}</td>
                        <td>{{ stock.stockCoverageStartDate | date : 'MM/dd/yyyy' }}</td>
                        <td>{{ stock.stockCoverageEndDate | date : 'MM/dd/yyyy' }}</td>
                        <td>{{ stock.status === 1 ? 'Reserved' : 'On-Hands' }}</td>
                        <td>{{ stock.customerName }}</td>
                        <td>{{ stock.stockOwner }}</td>
                        <td>{{ stock.purchaseDate | date : 'MM/dd/yyyy' }}</td>
                        <td>{{ stock.opportunity?.opportunityName || '' }}</td>
                        <td>{{ stock.price | currency: 'USD':'symbol' }}</td>
                        <td>{{ stock.poNumber }}</td>
                        <td>
                          <i class="pi" [ngClass]="{'pi-check-circle': stock.rabet, 'pi-times-circle': !stock.rabet}"></i>
                        </td>
                        <td>
                          <i class="pi" [ngClass]="{'pi-check-circle': !stock.customerStock, 'pi-times-circle': stock.customerStock}"></i>
                        </td>


                        <td alignFrozen="right" pFrozenColumn
                          *ngIf="(authenticationService.applanceRole.accessLevel ||0 )>= accessLevelEnum.read_write">
                          <p-button icon="pi pi-pencil" styleClass="mr-2" [rounded]="true" [outlined]="true"
                            severity="success" (onClick)="editStock(stock.stockId)"></p-button>
                          <p-button icon="pi pi-eye" [rounded]="true" [outlined]="true" severity="info"
                            (onClick)="viewStockItems(stock.stockId)"></p-button>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="16">No stocks found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>
</section>

<p-dialog [header]="dialogTitle" styleClass="custom-dialog" [modal]="true" [(visible)]="visible"
  [style]="{ width: '90%', height: '80%' }" [maximizable]="true">
  <div class="dialog-content">

    <div class="column">


      <div class="component">
        <app-products-lists [kind]="'all'" [(selectedCategory)]="selecteCategory" [(selectedType)]="selectedType"
          [(selectedItem)]="selectedItem" [(selectedProductId)]="stock.productId"
          (selectionChanged)="handleSelectionChanged($event)"></app-products-lists>

      </div>

      <div class="form-group">
        <label for="opp">Stock Status</label>
        <p-dropdown id="opp" [options]="statusOptions" placeholder="Select Status" class="full-width"
          [(ngModel)]="selectedStatus" [showClear]="true" (onChange)="onStatusChange()"></p-dropdown>
      </div>


      <!-- <div class="form-group">
        <label for="count">Batch Number</label>
        <input id="count" [(ngModel)]="selectedBatchNumber" type="number" placeholder="Enter Batch Number"
               class="full-width" />
      </div> -->

      <div class="form-group">
        <label for="batchNumber">Batch Number</label>
        <div class="full-width">
          <input id="batchNumber" type="text" pInputText [(ngModel)]="selectedBatchNumber" placeholder="Enter Batch Number" class="full-width" />
        </div>
      </div>
      

      <div class="form-group">
        <label for=" ProvisionValue"> Created By</label>
      

        <p-dropdown [options]="UserOptions" class="full-width" filter="true" name="sssOwnerName" required
        [(ngModel)]="selectedStockOwner" placeholder="Select..." [showClear]="true" 
        optionValue="userId" optionLabel="fullName">
        <ng-template let-option pTemplate="selectedItem">
            <div class="item">
                <div>{{option.fullName}}</div>
            </div>
        </ng-template>
        <ng-template let-option pTemplate="item">
            <span id="{{option.userId}}">{{option.fullName}}</span>
        </ng-template>
    </p-dropdown>

      </div>


      <div class="form-group checkbox-group">
        <label for="hasCoverage">Has Coverage</label>
        <p-checkbox id="hasCoverage" [(ngModel)]="hasCoverage" binary="true"
          (onChange)="hasCoverageChange()"></p-checkbox>
      </div>

      <div class="form-group">
        <label for="startDate">Start Date <span *ngIf="hasCoverage" class="required-indicator">*</span></label>
        <p-calendar [defaultDate]="today" id="startDate" [(ngModel)]="selectedstockCoverageStartDate"
          [disabled]="!hasCoverage" [showIcon]="true" icon="pi pi-calendar" placeholder="Select Start Date"
          class="full-width" [required]="hasCoverage"></p-calendar>
      </div>
    </div>


    <div class="column">
      <div class="form-group">
        <label for="customer">Customer Number - Customer Name</label>
        <p-dropdown id="customer" [options]="customerOptions" placeholder="Select Customer" optionLabel="customerName"
          optionValue="customerId" class="full-width" [(ngModel)]="selectedCustomerId" [virtualScroll]="true"
          [lazy]="true" [filter]="true" filterBy="customerName" [virtualScrollItemSize]="38" [showClear]="true"
          (onChange)="customerChange($event)" (onLazyLoad)="loadCustomersLazy($event)"
          [disabled]="selectedStatus === 2">
          <ng-template let-option pTemplate="item">
            <span id="{{option.customerId}}">{{option.customerNumber + ' - ' + option.customerName}}</span>
          </ng-template>
        </p-dropdown>
      </div>
      <div class="form-group">
        <label for="opp">Opportunity</label>
        <p-dropdown id="opp" [options]="opportunityOptions" optionLabel="opportunityName" optionValue="id"
          placeholder="Select Opportunity" class="full-width" [(ngModel)]="stock.opportunity.id" [showClear]="true"
          [disabled]="selectedStatus === 2"></p-dropdown>
      </div>

      <!-- <div class="form-group">
        <label for="count">Po. Number</label>
        <input id="count" [(ngModel)]="selectedPoNumber" type="number" placeholder="Enter Po. Number"
               class="full-width" />
      </div> -->

      <div class="form-group">
        <label for="count">Po. Number</label>
        <div class="full-width">

          <p-inputNumber id="count" [(ngModel)]="selectedPoNumber" placeholder="Enter Po. Number" class="full-width" />
        </div>
      </div>


      <div class="form-group">
        <label for="count">Quantity</label>
        <div class="full-width">

          <p-inputNumber id="count" [disabled]="dialogTitle == 'Edit Stock'" [(ngModel)]="selectedQuantity"
            placeholder="Enter quantity" class="full-width" />
        </div>
      </div>



      <div class="form-group">
        <label for="count">Price</label>
        <div class="full-width">

          <p-inputNumber id="count" [(ngModel)]="selectedPrice" type="number" placeholder="Enter Price"
            class="full-width" />
        </div>
      </div>
      <div class="form-group">
        <label for="endDate">Purchase Date</label>
        <p-calendar id="endDate" required [(ngModel)]="selectedPurchaseDate" [showIcon]="true" icon="pi pi-calendar"
          placeholder="Select Purchase Date" class="full-width"></p-calendar>
      </div>
      <div class="form-group checkbox-group" style="display: flex; align-items: center; gap: 10px; flex-direction: row;">
        <div style="display: flex; align-items: center;">
          <label for="rabet" style="margin-right: 5px;">Rabet</label>
          <p-checkbox id="rabet" [(ngModel)]="stock.rabet" binary="true"></p-checkbox>
        </div>
        <div style="display: flex; align-items: center;">
          <label for="sbm" style="margin-right: 5px;">Sbm Stock</label>
          <p-checkbox id="sbm" [(ngModel)]="stock.customerStock" binary="true"></p-checkbox>
        </div>
      </div>
    
      <div class="form-group">
        <label for="endDate">Coverage End Date <span *ngIf="hasCoverage" class="required-indicator">*</span></label>
        <p-calendar [defaultDate]="today" id="endDate" [disabled]="selectedstockCoverageStartDate == null"
          [minDate]="selectedstockCoverageStartDate"
          [(ngModel)]="selectedstockCoverageEndDate" [showIcon]="true" icon="pi pi-calendar"
          placeholder="Select End Date" class="full-width" [required]="hasCoverage"></p-calendar>
      </div>
    </div>

  </div>

  <div class="dialog-footer">
    <p-button label="Cancel" severity="secondary" (onClick)="closeDialog()"></p-button>
    <p-button label="Save" (onClick)="saveStock()"></p-button>
  </div>
</p-dialog>

<p-dialog header="Edit Stock Items" [(visible)]="itemsDialog" [modal]="true" [style]="{ width: '75vw' }">
  <p-table [value]="stockItems" editable="true">
    <ng-template pTemplate="header">
      <tr>
        <th>#</th>
        <th pEditableColumn field="serialNumber">Serial Number</th>
        <th pEditableColumn field="itemPurchaseDate">Coverage Start Date</th>
        <th pEditableColumn field="itemExpiryDate">Coverage End Date</th>
        <th pEditableColumn field="grDate">Gr Date</th>
        
        <th pEditableColumn field="sellingPrice">Selling Price</th>
        <th pEditableColumn field="costPrice">Cost Price</th>
        <th>Obsolete Item</th>
        <th>Order Number</th>
        <th>Opportunity Name</th>
        <th>Customer Name</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-i="rowIndex">
      <tr>
        <td>{{ i + 1 }}</td>
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText [(ngModel)]="item.serialNumber" placeholder="Enter Serial number" />
            </ng-template>
            <ng-template pTemplate="output">
              <span *ngIf="!item.serialNumber" class="placeholder-text">Enter Serial number</span>
              <span *ngIf="item.serialNumber">{{ item.serialNumber }}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [(ngModel)]="item.itemPurchaseDate" appendTo="body" dateFormat="yy-mm-dd"
                placeholder="Enter Purchase Date"></p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{ item.itemPurchaseDate | date: 'MM/dd/yyyy' }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [(ngModel)]="item.itemExpiryDate" appendTo="body" dateFormat="yy-mm-dd"
                placeholder="Enter Expiry Date"></p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{ item.itemExpiryDate | date: 'MM/dd/yyyy' }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-calendar [(ngModel)]="item.grDate" appendTo="body" dateFormat="yy-mm-dd"
                placeholder="Enter GR Date"></p-calendar>
            </ng-template>
            <ng-template pTemplate="output">
              {{ item.grDate | date: 'MM/dd/yyyy' }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText [(ngModel)]="item.sellingPrice" placeholder="Enter Selling Price" />
            </ng-template>
            <ng-template pTemplate="output">
              <span *ngIf="!item.sellingPrice" class="placeholder-text">Enter Selling Price</span>
              <span *ngIf="item.sellingPrice">{{ item.sellingPrice | currency: 'USD':'symbol' }}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td pEditableColumn>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText [(ngModel)]="item.costPrice" placeholder="Enter Cost Price" />
            </ng-template>
            <ng-template pTemplate="output">
              <span *ngIf="!item.costPrice" class="placeholder-text">Enter Cost Price</span>
              <span *ngIf="item.costPrice">{{ item.costPrice | currency: 'USD':'symbol' }}</span>
            </ng-template>
          </p-cellEditor>
        </td>
        <td>{{ item.absoluteItem ? 'Yes' : 'No' }}</td>
        <td>{{ item.orderNumber ?? 'No Orders' }}</td>
        <td>{{ item.opportunityName ?? 'No Opportunity' }}</td>
        <td>{{ item.customerName ?? 'No Customer' }}</td>
      </tr>
    </ng-template>
  </p-table>
  <div class="dialog-footer">
    <p-button label="Cancel" icon="pi pi-times" (onClick)="closeDialog()"></p-button>
    <p-button label="Save" icon="pi pi-check" (onClick)="saveStockItems()"></p-button>
  </div>
</p-dialog>

<p-toast></p-toast>